export default "__VITE_PUBLIC_ASSET__ae403e90__"